import {
    // Badge,
    // Button,
    // Card,
    // Navbar,
    // Nav,
    // Table,
    // Container,
    // Row,
    // Col,
    // Form,
    // OverlayTrigger,
    // Tooltip,
  } from "react-bootstrap";
import MainPanel from '../Components/MainPanel';
import SidePanel from '../Components/SidePanel';
  

const Dashboard = () => {


    return (
        <div className="Dashboard--wrapper">
            <SidePanel/>
            <MainPanel/>
        </div>
    );
}

export default Dashboard;